// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N_d4","field":"styles_field__3xi70","fieldCol":"styles_fieldCol__1KavC","diffCol":"styles_diffCol__1JV3S","diff":"styles_diff__3Da3D"};